<template>
	<div class="teacher">
		<list-template
        :loading="loading"
			:total="total"
			:table-data="tableData"
			:table-config="tableConfig"
			:search-config="searchConfig"
			:current-page="page"
			@onSearch="onSearch"
			@onReset="search = null"
			@onChangePage="changeCurrentPage"
			@onHandle="tableHandle"
			hasAdd
			@onAdd="onAdd"
		></list-template>
	</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
	_config:{"route":{"path":"list","meta":{"title":"列表","keepAlive":true}}},
  data() {
		return {
      loading:true,
			searchConfig: [
				{
					prop: 'school_id',
					placeholder: '请选择校区',
					tag: 'select',
					options: [],
          label: 'school_name',
          value: 'id'
				},
        {
					prop: 'grade_id',
					placeholder: '请选择年级',
					tag: 'select',
					options: [],
          label: 'name',
          value: 'id'
				},
				{
					prop: 'class_name',
					placeholder: '请输入班级名称'
				}
			],
			// 表格配置
			tableConfig: [
				{
					prop: 'class_name',
					label: '行政班名称'
				},
				{
					prop: 'school_name',
					label: '所属校区 '
				},
				{
					prop: 'room_name',
					label: '教室'
				},
				{
					prop: 'administrative_name',
					label: '行政班类型'
				},
        {
          prop:'teacher_name',
          label: '班主任'
        },
				{
					prop: 'grade_name',
					label: '年级'
				},
				{
					label: '操作',
					handle: true,
					width: 120,
					render: () => ['编辑']
				}
			],
			search: null,
			total: 0,
			dialogVisible: false,
			// 表格中的数据
			tableData: []
		}
	},
	computed: {
		...mapState(['page'])
	},
	mounted() {
		this.$store.commit('setPage', 1)
		this.getData()
	},
	activated() {
		this.getData()
	},
	methods: {
		// 分页被更改
		changeCurrentPage(e) {
			this.$store.commit('setPage', e)
			this.getData()
		},
		/**
		 * 获取数据
		 */
		getData() {
			let { search, page } = this;
      this.loading = true;
			this.$_axios.get('administration/list', { params: { ...search, page } }).then(res => {
				let { data } = res.data
				this.tableData = data
				let { total } = this.$tools.getPaginationInfo(res.headers)
				this.total = total
			}).finally(()=>this.loading = false);
		},
		// 新增按钮
		onAdd() {
			this.$router.push('./add')
		},
		// 搜索按钮被点击
		onSearch(val) {
			this.$store.commit('setPage', 1)
			this.search = val
			this.getData()
		},
		// 表格后面操作被点击
		tableHandle(row, handle, index) {
				this.$router.push({ path: './edit', query: { id: row.id } })
		}
	},
	created() {
		this.$_axios.get('site/school').then(res => {
      this.searchConfig[0].options = res.data.data
    })
		this.$_axios.get('site/grades').then(res => {
			this.searchConfig[1].options = res.data.data
		})
	}
}
</script>

<style scoped lang="scss">
.list {
	padding: 24rem 0 0 32rem;
	.search {
		.el-input,
		.el-select {
			width: 240rem;
			margin-right: 24rem;
		}
	}
	.pagination {
		margin-top: 50rem;
	}
}
</style>
